/* eslint-disable */
jQuery(function ($) {

  if (window.innerWidth < 768) {

    let $anchor = $('.find .filter-mobile')
      , $filterSidebar = $('.filter-sidebar')
      , body = $('body')
      , $filterButton = $('.filter-sidebar__button, .button-close')
      ;

    $anchor.click(function () {
      $filterSidebar
        .addClass('visible')
        ;

      if ($filterSidebar.hasClass('visible')) {
        body.addClass('no-scroll-filter');

        $filterSidebar.animate({
          scrollTop: 0
        }, "slow");
      }
    });

    $filterButton.click(function () {
      $filterSidebar
        .removeClass('visible show--button')
        ;
      body
        .removeClass('no-scroll-filter')
        ;
    });

    $filterSidebar.scroll(function () {
      let scrolltop = $($filterSidebar).scrollTop();

      $filterSidebar.removeClass('show--button');
      if (scrolltop > 40) {
        $filterSidebar.addClass('show--button');
      }
    });
  }

});
